import React, {useEffect, useState, useRef} from 'react';
import {Box, Spinner, useDimensions} from '@chakra-ui/react';
import Post from './InsightDetail/Components/post';
import More from './InsightDetail/Components/more';
import {useParams} from "react-router-dom";
import axios from "axios";
import {SEO} from "../components/SEO";
import FullCrossPlus from '../components/FullCrossPlus';
import Container from "../components/Container";

const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
};

const InsightDetailPage = () => {
    const [insightsData, setInsightsData] = useState(undefined)
    const {slug} = useParams();

    const pageRef = useRef();

    const dimen = useDimensions(pageRef, true);

    const count = Math.floor(dimen?.contentBox.height / 393) + 1 || 0;

    const isMobile = dimen?.contentBox.width < 768;

    useEffect(() => {
        const abortController = new AbortController();
        const fetchInsights = async () => {
            const response = await axios.get(`/wp-json/wp/v2/posts?_embed&acf_format=standard&slug=${slug}`, {signal: abortController.signal}).then(resp => {
                return resp.data[0];
            });
            setInsightsData(response)
            scrollToTop();
        }
        fetchInsights()
        return () => {
            abortController.abort();
        }
    }, [slug])

    return (
        <Box>
            <SEO
                image={insightsData?.yoast_head_json?.og_image ? insightsData?.yoast_head_json?.og_image[0]?.url : null}
                title={insightsData?.title?.rendered}
                ogTitle={insightsData?.yoast_head_json?.og_title}
                description={insightsData?.yoast_head_json?.og_description}
                url={insightsData?.yoast_head_json?.og_url}
                type={insightsData?.yoast_head_json?.og_type}
                siteName={insightsData?.yoast_head_json?.og_site_name}
                robots={`${insightsData?.yoast_head_json?.robots.index}, ${insightsData?.yoast_head_json?.robots.follow}`}
            />
            <Box textAlign={'left'} px={['5', '10']} ref={pageRef}>
                {!isMobile && Array(count)
                    .fill('')
                    .map((_, key) => (
                        <FullCrossPlus index={key + 1} top={393 * (key + 1)} key={key}/>
                    ))}
                <Box borderX={'1px'} borderColor={'brandAlpha.200'} pb={'50px'}>
                    <Container>
                        <Box minH={'100vh'} display={'flex'} flexDirection={{base: 'column', md: 'row'}}
                             px={{base: '20px', md: '0'}}>
                            {!insightsData ? (
                                <Box my={20}>
                                    <Spinner color='blue.600' size='xl'/>
                                </Box>
                            ) : (
                                <>
                                    <Box pl={{base:0, md:'20px'}} pt={{base: '49px', md: '47px'}} flex={'1 1 100%'} maxWidth='100%'>
                                        <Post data={insightsData}/>
                                    </Box>
                                    <Box
                                        pr={'20px'}
                                        pt={{base: '80px', md: '53px'}}
                                        flex={'0 0 315px'}
                                        position={'relative'}
                                    >
                                        <Box position={'sticky'} top={'52px'}>
                                            <More data={insightsData}/>
                                        </Box>
                                    </Box>
                                </>
                            )}

                        </Box>
                    </Container>
                </Box>
            </Box>
        </Box>
    );
};

export default InsightDetailPage;
